//#region Util Imports

import * as _ from 'underscore'
import * as $ from 'jquery'

//#endregion

//#region DevExtreme Imports

import DevExpress from 'devextreme'
import 'devextreme/ui/button'
import 'devextreme/ui/load_indicator'
import 'devextreme/ui/popover'

//#endregion

import { i18n } from '../../common/i18n/common.i18n'
import { Api } from '../../api/api.module'
import { GridOptions, GridTypes } from '../../common/grid/grid.controller'
import { EventsNames } from '../../../helpers/events-names'
import { Permissions } from '../../../helpers/permissions'
import { TemplateHelper, ConfigHelper, TypeHelper } from '../../../helpers'

import { IReferenceType } from '../../../models/util/interfaces'
import { IUserSession } from '../../../helpers/user-session'
import { Enums } from '../../../models/common/enums'
import { Activity } from '../../../models/common/activity'

import { OpDashboardControl } from '../../../models/custom/op-dashboard-control'
import { OpTileControl } from '../../../models/custom/op-tile-control'
import { OpAlarmEvent } from '../../../models/dw'
import { SYSTEM_SERVICE_NAME, SystemService } from '../../../services/system'
import { USER_SESSION_SERVICE_NAME } from '../../../services/user-session'

//#region Asset Imports

import './alarms-menu.scss'
import * as TEMPLATE from './alarms-menu.tpl.html'

//#endregion

interface AlarmsMenuScope extends ng.IScope {
    options: any
    menuPopoverOptions: DevExpress.ui.dxPopoverOptions
    refreshButtonOptions: DevExpress.ui.dxButtonOptions
    alarmsMenuGridOptions: GridOptions
    showGrid: boolean
}

export class AlarmsMenuDirective implements ng.IDirective {
    constructor() {

    }

    restrict = 'E'
    scope = {
        options: '='
    }

    controller = ['$scope', 'api', '$timeout', SYSTEM_SERVICE_NAME, USER_SESSION_SERVICE_NAME, ($scope: AlarmsMenuScope, api: Api, $timeout: ng.ITimeoutService, systemService: SystemService, userSession: IUserSession) => {
        var gridDeferred = $.Deferred<DevExpress.ui.dxDataGrid>()

        var loadGrid = (values: OpDashboardControl[]) => {
            gridDeferred.then(grid => {
                grid.option("dataSource").store().clear()

                if (values) {
                    var store = grid.option("dataSource").store()
                    values.forEach(value => {
                        if (value.class == Enums.DashboardItemClass.TILE) {
                            var tileControl: OpTileControl = <OpTileControl>value
                            var text = (tileControl.textHeader ? tileControl.textHeader.toString() : '') + ': ' + (' (' + value.referencecData ? value.referencecData.length.toString() : '0' + ')')
                            store.insert({
                                name: text,
                                refid: value.referencecData.map(k => { return (<IReferenceType><any>k).getReferenceKey() }),
                                refdata: value.referencecData.map(k => {

                                    if (k instanceof OpAlarmEvent) {
                                        return this.getAlarmEventReferenceData(k)
                                    }

                                    return (<IReferenceType><any>k).toString()
                                }),
                                reftype: value.referenceType,
                            })
                        }
                    })
                }

                grid.refresh()
                $scope.showGrid = true
            })
        }

        $scope.menuPopoverOptions = {
            width: 400,
            height: 500,
            target: '.alarm-button',
            bindingOptions: {
                visible: 'options.popoverVisible'
            },
            onHiding: () => {
                $scope.options.popoverVisible = false
            },
            onShown: () => {
                loadGrid($scope.$root['alarmTiles'])
            }
        }

        $scope.alarmsMenuGridOptions = null
        $timeout(() => {
            $scope.alarmsMenuGridOptions = {
                name: null,
                idReferenceType: Enums.ReferenceType.IdAlarmEvent,
                type: GridTypes.PAGINATED_SMALL,
                buttonsOptions: {
                    enabled: false,
                },
                addCustomFilters: false,
                columns: [
                    {
                        dataField: 'name',
                        caption: i18n('Common', 'Name'),
                        allowEditing: false,
                        dataType: 'string'
                    }
                ],
                onInitialized: (e) => {
                    gridDeferred.resolve(e.component)
                },
                onRowClick: (e) => {
                    Permissions.hasPermissions([Permissions.ALARM_LIST]).then(permission => {
                        if (permission) {
                            systemService.openDetailsOrModule({
                                idReferenceType: e.data.reftype,
                                referenceObjectIds: e.data.refid
                            })
                        }
                    })
                },
                onCellPrepared: e => {
                    if (e.column.command === "expand") {
                        if (e.rowType === "data" && (!e.data.refdata || e.data.refdata.length == 0)) {
                            e.component.collapseRow(e.key)
                        }
                        e.cellElement.removeClass("dx-datagrid-expand")
                        e.cellElement.empty()
                    } else if (e.rowType == "detail") {
                        e.cellElement.addClass("alarm-grid-row-cell")
                    }
                },
                masterDetail: {
                    enabled: true,
                    template: "detail",
                    autoExpandAll: true
                }
            }
        })

        $scope.refreshButtonOptions = {
            onClick: () => {
                $scope.showGrid = false
                userSession.getDataProvider().Operator.getLoggedOperator(true).then(loggedOperator => {
                    if (loggedOperator && loggedOperator.hasPermission(Activity.WEBSIMAX_ALARM_SUMMARY_VIEW)) {
                        userSession.getDataProvider().AlarmEvent.getAlarmEventSummary(loggedOperator.idOperator).then(result => {
                            $scope.$root.$broadcast('enableLoadingIndicator')
                            var alarmCount: number = 0
                            if (result)
                                result.forEach(r => {
                                    alarmCount += r.referencecData && r.referencecData.length > 0 ? r.referencecData.length : 1
                                })
                            $scope.$root['alarmsCount'] = alarmCount
                            $scope.$root['alarmTiles'] = result
                            loadGrid(result)
                        })
                    }
                })
            },
            template: TemplateHelper.getIcon(ConfigHelper.Icon.REFRESH, userSession),
            hint: i18n("Grid", "Refresh")
        }

        //close popover on ESC press
        $scope.$on(EventsNames.ESC_KEY_PRESS, () => {
            if ($scope.alarmsMenuGridOptions) {
                $timeout(() => {
                    $scope.options.popoverVisible = false
                })
            }
        })

    }]

    template = TEMPLATE
    replace = true

    private getAlarmEventReferenceData(alarmEvent: OpAlarmEvent): any {
        if (alarmEvent != null) {
            const message: string = alarmEvent.alarmMessage != null ? alarmEvent.alarmMessage.toString() : null

            if (TypeHelper.containsHTMLTags(message)) {
                if (alarmEvent.location != null) {
                    return alarmEvent.location.toString()
                }

                if (alarmEvent.device != null) {
                    return alarmEvent.device.toString()
                }
            }

            return alarmEvent.toString()
        }

        return null
    }
}